export default __webpack_public_path__ + "static/media/Glitter_logotype_horizontal-01.2a7ebdef.png";